import { useNavigate } from 'react-router-dom';
import { useOrder } from '../context/OrderContext';

export function FloatingBar() {
  const { items } = useOrder();
  const navigate = useNavigate();

  if (items.length === 0) return null;

  return (
    <div className="floating-bar">
      <div className="floating-bar-inner">
        <span className="text-muted">
          {items.length} {items.length === 1 ? 'Produkt' : 'Produkte'} ausgewählt
        </span>
        <button className="btn btn-primary" onClick={() => navigate('/checkout')}>
          Weiter →
        </button>
      </div>
    </div>
  );
}
